import { connect } from "react-redux";

import { ReactComponent as PGIcon } from "icons/pg-square.svg";

const AsidePanel = ({ product_group }) => (
  <ul className="product-list">
    <li className="product-list__item active">
      <div className="item-icon">
        <PGIcon />
      </div>
      <div className="item-text">
        <p className="title">{product_group.name}</p>
        <p>{product_group.sku}</p>
      </div>
    </li>
  </ul>
);

export default connect(({ product_group: { data } }) => ({
  product_group: data,
}))(AsidePanel);
